/* eslint-disable no-undef */
import React, { useEffect } from 'react'
import ModalCustom from '../../../modal-custom'
import { Button, Col, Form } from 'react-bootstrap'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import { Controller, useForm } from 'react-hook-form'
import { updateTeamsAPI, deleteTeamsAPI } from '../../../../services/teams'
import LabelCustom from '../../../label-custom'
import Error_false from '../../../error/error-false'
import Swal from 'sweetalert2'
import SwalCustom from '../../../../alert/swal-custom'
import { TXTSUCCESS } from '../../../../Constants'

const schema = yup
  .object({
    teamEn: yup.string().required('Please, Input team for English'),
    teamTh: yup.string().required('Please, Input team for Thai'),
  })
  .required()
export default function EditTeam({
  setIsSave,
  showCreate,
  isSave,
  setShowCreate,
  detail,
  orgId,
  departmentId,
  divisionId,
  setIsRefresh,
  handleKeyDownTH,
  handleKeyDownEN,
  handleKeyDownNum,
}) {
  const {
    control,
    setValue,
    setError,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  })

  useEffect(() => {
    setValue('teamEn', detail.team_en ?? '')
    setError('teamEn', false)

    setValue('teamTh', detail.team_th ?? '')
    setError('teamTh', false)
    setValue('larkEnable', detail.lark_enable ?? false)
  }, [detail.team_en, detail.team_th, detail.lark_enable, setError, setValue])

  //update function
  const onSubmit = (body) => {
    const param = {
      teamId: detail.id,
      orgId,
      departmentId,
      divisionId,
    }
    SwalCustom({
      title: 'Are you sure?',
      text: 'Do you want to save the changes?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#2C5DFE',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, save it!',
    }).then((result) => {
      if (result.isConfirmed) {
        setIsSave(true)
        updateTeam(param, body)
      }
    })
  }

  const updateTeam = async (param, body) => {
    const results = await updateTeamsAPI(param, {
      ...body,
      larkEnable: body.larkEnable ?? false,
    })

    if (!results) {
      setIsSave(false)
      return
    }

    if (results.status) {
      SwalCustom({
        title: `Success!`,
        text: TXTSUCCESS,
        timer: 1500,
        showConfirmButton: false,
      }).then(() => {
        setIsRefresh(true)
        setShowCreate(false)
        Swal.close()
      })
    } else {
      Error_false(results)
    }
    setIsSave(false)
    fnReset()
  }

  const fnReset = () => {
    setError('teamEn', false)
    setError('teamTh', false)
  }

  const handleClose = () => {
    setShowCreate(false)
    fnReset()
  }

  const handleOnDelete = (result) => {
    const param = { teamId: detail.id, orgId: orgId }

    SwalCustom({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#2C5DFE',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!',
    })
      .then(async (result) => {
        if (result.isConfirmed) {
          const results = await deleteTeamsAPI(param)
          if (results.status) {
            setShowCreate(false)
          }
          Swal.fire('Deleted!', 'Your file has been deleted.', 'success')
        }
      })
      .then(() => {
        setIsRefresh(true)
      })
  }

  return (
    <ModalCustom width={500} open={showCreate} onCancel={handleClose}>
      <Form
        onSubmit={handleSubmit(onSubmit)}
        className="mt-3 row"
        style={{ rowGap: '13px' }}
      >
        <label>Update Team</label>

        <Col md={12}>
          <LabelCustom text={'Team EN'} />
          <Controller
            name={'teamEn'}
            control={control}
            render={({ field: { onChange, value = '' } }) => (
              <Form.Control
                maxLength={100}
                value={value}
                onChange={onChange}
                // onKeyDown={handleKeyDownEN}
              />
            )}
          />
          {errors.teamEn?.message && (
            <label className="small text-danger">{errors.teamEn.message}</label>
          )}
        </Col>

        <Col md={12}>
          <LabelCustom text={'Team TH'} />
          <Controller
            name={'teamTh'}
            control={control}
            render={({ field: { onChange, value = '' } }) => (
              <Form.Control
                maxLength={100}
                value={value}
                onChange={onChange}
                // onKeyDown={handleKeyDownTH}
              />
            )}
          />
          {errors.teamTh?.message && (
            <label className="small text-danger">{errors.teamTh.message}</label>
          )}
        </Col>

        <Col md={12}>
          <Controller
            name={'larkEnable'}
            control={control}
            render={({ field: { onChange, value = '' } }) => (
              <Form.Group
                className="mb-3"
                controlId="formBasicCheckbox"
                value={value}
                onChange={onChange}
              >
                <Form.Check
                  checked={value}
                  type="checkbox"
                  label="Lark Enable"
                />
              </Form.Group>
            )}
          />
        </Col>

        <Col xl={12} className="text-center ">
          {detail.count_emp === 0 && (
            <Button
              // data={orgId}
              className="px-4 me-2 bg-danger text-white"
              variant="light"
              type="button"
              disabled={isSave}
              onClick={handleOnDelete}
            >
              Delete
            </Button>
          )}{' '}
          <Button
            className="px-4 "
            disabled={isSave}
            type="submit"
            // onClick={onSubmit}
          >
            {isSave ? 'Saving...' : 'Save'}
          </Button>
        </Col>
      </Form>
    </ModalCustom>
  )
}
